import * as queryString from 'query-string';
import API from '../api';
import * as actions from '../constants';
import generateActions from './baseAction';
import PAGINATE from '../../data/paginate';

const {
  showError,
  clearErrors,
  filterDrivers,
  getAllDrivers,
  getDriver,
  addDriver,
  updateDriver,
  removeDriver,
  requestGetDrivers,
  receiveGetDrivers,
} = generateActions('driver', 'drivers');

/**
 * Search for a driver
 * @param {String} name
 */
const searchDrivers = (name) => (dispatch) => {
  dispatch({ name, type: actions.REQUEST_SEARCH_DRIVERS });
  const query: any = { name };
  return API.request(`/drivers/search/?${queryString.stringify(query)}`)
    .then((response) => response.json())
    .then((response) => {
      dispatch({ type: actions.RECEIVE_SEARCH_DRIVERS });
      return response;
    })
    .catch((err) => {
      dispatch({ type: actions.RECEIVE_SEARCH_DRIVERS });
      return false;
    });
};

const getRevision = (driverId, revisionId) => (dispatch) => {
  return API.request(`/drivers/${driverId}/revision/${revisionId}`)
    .then((response) => response.json())
    .then((response) => {
      return response;
    });
};

/**
 * Get the bookings related to the driver
 * @param {Number} id
 * @param {Number} offset
 * @param {Number} limit
 */
const getDriverBookings = (
  id,
  offset = 0,
  limit = PAGINATE.bookingRelations.MAX,
) => (dispatch) => {
  dispatch({ type: actions.REQUEST_DRIVER_BOOKINGS });
  return API.request(
    `/drivers/${id}/bookings?${queryString.stringify({
      offset,
      limit,
    })}`,
  )
    .then((response) => response.json())
    .then((response) => {
      dispatch({ type: actions.RECEIVE_DRIVER_BOOKINGS });
      return response;
    })
    .catch((err) => {
      dispatch({ type: actions.RECEIVE_DRIVER_BOOKINGS });
      return false;
    });
};

const getDrivers = (
  date = new Date(),
  page: number = 0,
  search: string = '',
) => (dispatch) => {
  dispatch(requestGetDrivers());
  return API.request(
    `/drivers?page=${page}&limit=${PAGINATE.drivers.MAX}&search=${search}`,
  )
    .then((response) => response.json())
    .then((response) => {
      dispatch(receiveGetDrivers(response.error, response.data, date));
      return response;
    });
};

/**
 * Request the payments associated with the driver
 */
const getDriverPayments = ({
  id = 0,
  page = 0,
  limit = PAGINATE.payments.MAX,
  order,
  sort,
}) => (dispatch) => {
  const query = {
    page,
    limit,
    order,
    sort,
  };
  dispatch({
    type: actions.REQUEST_DRIVER_PAYMENTS,
  });
  return API.request(`/drivers/${id}/payments?${queryString.stringify(query)}`)
    .then((response) => response.json())
    .then((response) => {
      dispatch({
        response,
        type: actions.RECEIVE_DRIVER_PAYMENTS,
      });
      return response;
    });
};

const getCompanyDrivers = (companyId: number, page: number = 0) => (
  dispatch,
) => {
  dispatch(requestGetDrivers());
  return API.request(
    `/drivers/company/${companyId}?page=${page}&limit=${PAGINATE.companyDrivers.MAX}`,
  )
    .then((response) => response.json())
    .then((response) => {
      dispatch(receiveGetDrivers(response.error, response.data));
      return response;
    });
};

/**
 * Merge a list of drivers into one
 */
const mergeDrivers = (driverIds, overrides?) => async (dispatch) => {
  dispatch({
    type: actions.REQUEST_MERGE_DRIVERS,
  });
  const response = await (await API.request('/drivers/merge', 'POST', {
    overrides: JSON.stringify(overrides),
    driverIds: JSON.stringify(driverIds),
  })).json();
  dispatch({
    data: response.data,
    error: response.error,
    type: actions.RECEIVE_MERGE_DRIVERS,
  });
  return response;
};

export {
  addDriver,
  clearErrors,
  filterDrivers,
  getAllDrivers,
  getDriver,
  getDriverBookings,
  getDriverPayments,
  getCompanyDrivers,
  getDrivers,
  mergeDrivers,
  removeDriver,
  searchDrivers,
  showError,
  updateDriver,
  getRevision,
};
